import { defineStore } from "pinia";
import { webhookService } from "@/_services";

export const webhookStore = defineStore("webhookStore", {
  state: () => ({
    error: null,
    list: null,
    deleted: null,
    created: null,
    updated: null,
    webhook: null
  }),
  actions: {
    getWebhooks() {
      webhookService
        .getWebhooks()
        .then((results) => (this.list = results))
        .catch((reason) => (this.error = reason));
    },
    getWebhook(id) {
      webhookService
        .getWebhook(id)
        .then((results) => (this.webhook = results))
        .catch((reason) => (this.error = reason));
    },
    newWebhook(body) {
      webhookService
        .newWebhook(body)
        .then((results) => (this.created = results))
        .catch((reason) => (this.error = reason));
    },
    editWebhook(body) {
      this.updated = null;
      webhookService
        .editWebhook(body._id, body)
        .then((results) => (this.updated = results))
        .catch((reason) => (this.error = reason));
    },
    deleteWebhook(idKey) {
      this.deleted = null;
      webhookService
        .deleteWebhook(idKey)
        .then((results) => (this.deleted = results))
        .catch((reason) => (this.error = reason));
    },
  },
});
